module.exports = __webpack_public_path__ + "static/media/saml-color.93af02fe.svg";